import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginAdminComponent } from './pagina-admin/login-admin/login-admin.component';
import { DashboardComponent } from './pagina-admin/dashboard/dashboard/dashboard.component';

//mantenimiento
import { GestionUsuarioComponent } from './pagina-admin/dashboard/gestion-usuario/gestion-usuario.component';
import { DatosPersonalesComponent } from './pagina-admin/dashboard/gestion-usuario/datos-personales/datos-personales.component';
import { GestionPlantillaComponent } from './pagina-admin/dashboard/gestion-plantilla/gestion-plantilla.component';
import { GestionConstanciaComponent } from './pagina-admin/dashboard/gestion-constancia/gestion-constancia.component';
import { GestionParticipanteComponent } from './pagina-admin/dashboard/gestion-participante/gestion-participante.component';
import { GestionConstanciaFirmaComponent } from './pagina-admin/dashboard/gestion-constancia-firma/gestion-constancia-firma.component';
import { GestionParticipanteFirmaComponent } from './pagina-admin/dashboard/gestion-participante-firma/gestion-participante-firma.component';
import { DmlFirmaComponent } from './pagina-admin/dashboard/gestion-participante-firma/dml-firma/dml-firma.component';
import { DmlFirmadoComponent } from './pagina-admin/dashboard/gestion-participante-firma/dml-firmado/dml-firmado.component';
import { DmlFirmaMensajeComponent } from './pagina-admin/dashboard/gestion-participante-firma/dml-firma-mensaje/dml-firma-mensaje.component';
import { ReporteEmitidosComponent } from './pagina-admin/dashboard/reporte/reporte-emitidos.component';
import { ReporteTotalAlumnosComponent } from './pagina-admin/dashboard/reporte/reporte-total-alumnos.component';
import { ResumenComponent } from './pagina-admin/dashboard/resumen/resumen.component';
import { GestionCorreoComponent } from './pagina-admin/dashboard/gestion-correo/gestion-correo.component';
import { VerificarComponent } from './pagina-admin/verificar/verificar.component';

const routes: Routes = [
  {path:'',component: LoginAdminComponent},
  {path:'verificacion',component: VerificarComponent},
  {path:'dashboard',component: DashboardComponent,children: [
      {path:'inicio',component: ResumenComponent},
      {path:'gestionusuario',component: GestionUsuarioComponent},
      {path:'gestionconstancia/:tipo',component: GestionConstanciaComponent},//tipo Alumno o Profesor
      {path:'gestionparticipante/:tipo/:id',component: GestionParticipanteComponent},//tipo Alumno o Profesor
      {path:'gestionplantilla',component: GestionPlantillaComponent},
      {path:'datospersonales',component: DatosPersonalesComponent},
      {path:'gestionconstanciafirma/:tipo',component: GestionConstanciaFirmaComponent},//tipo Alumno o Profesor
      {path:'gestionparticipantefirma/:tipo/:id',component: GestionParticipanteFirmaComponent},//tipo Alumno o Profesor
      {path:'firmar/:tipo/:id',component: DmlFirmaComponent},//tipo Masivo o Unitario -  id consta o id firma
      {path:'firmado/:tipo/:id',component: DmlFirmadoComponent},//tipo consulta(Registro o Firma) - id parti
      {path:'firmamensaje/:tipo/:idc/:idp/:archivo',component: DmlFirmaMensajeComponent},//tipo Alumno o Profesor, id constancia, id firma, nombre_archivo
      {path:'reporteemitidos',component: ReporteEmitidosComponent},
      {path:'reportetotalalumnos',component: ReporteTotalAlumnosComponent},
      {path:'gestioncorreo',component: GestionCorreoComponent},
    ]},
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    scrollPositionRestoration: 'enabled',
  })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
